module.exports = __webpack_public_path__ + "static/media/githubProfilePic.93693519.png";